import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "image-set" }

import Page from "@/components/page/Page.vue";
import ImageContainer from "@/components/image-container/ImageContainer.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Mission',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, null, {
    default: _withCtx(() => [
      _cache[12] || (_cache[12] = _createElementVNode("h2", null, "\"Het hele land kleurt PVV!\"", -1)),
      _createElementVNode("section", null, [
        _cache[0] || (_cache[0] = _createElementVNode("p", null, " Na de verkiezingen van 22 november 2023 verschenen weer allerlei koppen in de kranten met de strekking van \"Nederland kleurt PVV\" ", -1)),
        _createVNode(ImageContainer, {
          label: "Volkskrant 24 november 2023",
          href: "https://www.volkskrant.nl/politiek/in-grafieken-het-hele-land-kleurt-pvv-links-is-historisch-klein~b73ba7c8/?referrer=https://www.google.com/",
          "image-alt": "kop Volkskrant",
          image: "img/doel/kop-volkskrant.png"
        })
      ]),
      _createElementVNode("section", null, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Verkiezingskaarten in de media", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ImageContainer, {
            size: 250,
            label: "RTL",
            href: "https://www.rtlnieuws.nl/nieuws/politiek/artikel/5419811/verkiezingsuitslag-tweede-kamer-stemmen-uitslag",
            "image-alt": "Verkiezingskaart RTL",
            image: "img/doel/rtl.png"
          }),
          _createVNode(ImageContainer, {
            size: 250,
            label: "NOS",
            href: "https://app.nos.nl/nieuws/tk2023/",
            "image-alt": "Verkiezingskaart NOS",
            image: "img/doel/nos1.png"
          })
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("p", null, " En inderdaad, de kaarten laten een land zien dat volledig omgeslagen is naar PVV (voor de kaartmakers is het nog even wennen welke kleur PVV te geven; RTL koos voor grijzig, NOS voor lichtblauw. Ook GL+PvdA is wennen, zijn ze nou rood of groen? Wij kozen er overigens voor om de NOS kleuren te volgen). ", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", null, " Alleen de grote (studenten)steden laten voornamelijk GL+PVDA zien en heel Twente kleurde in het geel van NSC. Dus niet gek dat we het ook de hele tijd hebben over \"de Stad\" vs. \"het Platteland\". ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "TOCH?", -1))
      ]),
      _createElementVNode("section", null, [
        _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Weilanden mogen niet kiezen", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("p", null, " Wat sowieso al een flinke gevoelsmatige vertekening geeft in deze kaarten, is het feit dat de blauwe vlek van bijv. de gemeente Het Hogeland (met zo'n 48 duizend inwoners) 3x zo groot is als de rode vlek van Amsterdam (met bijna 20x zo veel inwoners!) ", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", null, [
          _createTextVNode(" NOS heeft deze jaargang gekozen voor een aparte modus waarmee je kan wisselen van de traditionele kaart (waarin Het Hogeland dus 3x zwaarder mee lijkt te tellen dan Amsterdam) en een zogenaamde "),
          _createElementVNode("i", null, "cartogram"),
          _createTextVNode(", waarin de representatie van de gemeenten is gecorrigeerd voor het aantal inwoners. ")
        ], -1)),
        _cache[8] || (_cache[8] = _createElementVNode("p", null, [
          _createTextVNode(" Is de kop \"links is historisch klein\" dan nog steeds gerechtvaardigd?"),
          _createElementVNode("br"),
          _createTextVNode(" Het zal cijfermatig vast wel zo zijn, maar is het dé significante trend die we zien? ")
        ], -1)),
        _createVNode(ImageContainer, {
          size: 250,
          label: "NOS",
          href: "https://app.nos.nl/nieuws/tk2023/",
          "image-alt": "Verkiezingskaart NOS",
          image: "img/doel/nos2.png"
        })
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("section", null, [
        _createElementVNode("h3", null, "Missende kiezers op de kaart"),
        _createElementVNode("p", null, [
          _createTextVNode(" In Rotterdam kozen 58 duizend stemmers voor GL+PvdA. Ze staan niet op deze kaarten."),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createTextVNode(" In Den Haag 47 duizend, ook zij staan niet op de kaarten."),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createTextVNode(" En Amsterdam een duidelijk links bolwerk? 49 duizend stemmen voor VVD, 41 duizend voor D66 en 40 duizend voor PVV. Ook zij staan allemaal niet op de kaarten. ")
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(" Op de kaart van 2023 volgens het gekozen principe (dus die van oa RTL en NOS) "),
          _createElementVNode("strong", null, " is slecht 27.6% van de stemmen zichtbaar!")
        ])
      ], -1)),
      _createElementVNode("section", null, [
        _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Winner takes it all?", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("p", null, [
          _createTextVNode(" Wellicht is deze manier van kaartmaken geinspireerd door de verkiezingen in de VS, waar de winnaar van een staat alle kiesmannen krijgt. (zie overigens "),
          _createElementVNode("a", {
            href: "https://www.nytimes.com/interactive/2016/11/01/upshot/many-ways-to-map-election-results.html",
            target: "_blank"
          }, "dit artikel"),
          _createTextVNode(" over afwegingen die de NY Times maakte in hun verkiezingskaarten) ")
        ], -1)),
        _cache[11] || (_cache[11] = _createElementVNode("p", null, [
          _createTextVNode(" Maar ons systeem is anders, bij ons geldt niet \"winner takes it all\". Ook die 58 duizend stemmers voor GL+PvdA tellen mee."),
          _createElementVNode("br"),
          _createTextVNode(" Ook de vijf stemmers in Rozendaal (Gelderland) die op JA21 (kleinste partij met 1 zetel) hebben iemand die hun stem vertegenwoordigt in de Tweede Kamer. ")
        ], -1)),
        _createVNode(ImageContainer, {
          size: 250,
          "image-alt": "Verkiezingskaart VS",
          image: "img/doel/usa.jpeg"
        })
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("section", null, [
        _createElementVNode("h3", null, "Waarom eigenlijk een kaart?"),
        _createElementVNode("p", null, [
          _createTextVNode(" Het medium "),
          _createElementVNode("b", null, "kaart"),
          _createTextVNode(" is voor ontwerpers en developers een aantrekkelijke manier om de verkiezingsuitslag te visualiseren. Maar het heeft een aantal intrinsieke nadelen die gevoelsmatige vertekeningen geven. ")
        ]),
        _createElementVNode("p", null, " Waarom kiezen we eigenlijk voor een kaart? Wat is het verschil met een tabel/lijst met alle gemeenten/partijen/stemmen? Want dat is bij uitstek de manier om het wie/wat/waar te communiceren. "),
        _createElementVNode("p", null, " Blijkbaar willen we meer vertellen of iets anders kunnen vertellen/analyseren. Willen we verbanden zien, dingen als \"de stad\" vs. \"het platteland\", de \"Biblebelt\", of welke kleur blijkbaar het land dit jaar heeft. ")
      ], -1)),
      _cache[15] || (_cache[15] = _createElementVNode("section", null, [
        _createElementVNode("h3", null, "Ambitie"),
        _createElementVNode("p", null, [
          _createTextVNode(" De ambitie van dit project is een alternatieve kaart te maken, die nog steeds de antwoorden probeert te geven op vragen als:"),
          _createElementVNode("br"),
          _createTextVNode(" Welke kleur is het land dit jaar?"),
          _createElementVNode("br"),
          _createTextVNode(" Zijn er regionale trends of verbanden te zien?"),
          _createElementVNode("br"),
          _createTextVNode(" Wat stemt \"de Stad\"? En stemt \"het Platteland\" zoveel anders? ")
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(" In de keuzes die we maken mag het wie/wat/waar iets aan concessies doen, want als je dat wilt weten zijn de tabellen er immers ook nog steeds."),
          _createElementVNode("br"),
          _createTextVNode(" En een laatste uitdaging is om de kaart iconisch te houden, de unieke vorm van Nederland moet wel behouden blijven. ")
        ])
      ], -1))
    ]),
    _: 1
  }))
}
}

})